import React from 'react';
import classNames from 'classnames';

import { ReservedModal } from './ReservedModal';
import { Tab, TabbedCards } from '../../ui/tabs';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { useFlags } from 'launchdarkly-react-client-sdk';
import Icon from '../../ui/icon/icon';
import { useClipboard } from '@mantine/hooks';
import { Button } from '@frontend/shared-ui-kit/button';
import { ArrowLeft } from 'react-feather';
import { useAppState } from '@frontend/howl-web-app/overmind';
import { useToast } from '@frontend/shared-ui-kit/v2/toaster';
import { Button as ButtonV2 } from '@frontend/shared-ui-kit/v2/button';

const CampaignCenterWrapper = ({
  brand,
  campaign,
  flatFee,
  children,
  merchantPreview,
  previewCampaignId,
  merchantId,
  showShare = false,
  disableTabs = false,
}: {
  brand?: boolean;
  campaign?: boolean;
  flatFee?: boolean;
  children: React.ReactNode;
  merchantPreview?: boolean;
  previewCampaignId?: number;
  merchantId?: number;
  ioId?: number;
  showShare?: boolean;
  disableTabs?: boolean;
}) => {
  const router = useRouter();
  const flags = useFlags();
  const strategy_id = router.query.campaignId;
  const clipboard = useClipboard();
  const { selectedOrgId } = useAppState().organization;
  const { toast } = useToast();
  const handleBack = () => {
    const path = router.asPath.split('/');
    const newPath = path.slice(0, path.length - 1).join('/');
    router.push(newPath);
  };
  return (
    <div className="pt-4 sm:pt-24 flex flex-col container mx-auto px-4 sm:px-8 pb-32">
      {!disableTabs && (
        <div className="text-2xl text-center font-bold flex items-center">
          <h1 className="mb-3">Campaign Center</h1>
          {merchantPreview && !router.query.strategyId && (
            <Link
              href={`/merchant/${merchantId}/campaign-center/campaigns/${previewCampaignId}/preview`}
              legacyBehavior
            >
              <Button className={'mb-3'} variant="outline" leftIcon="linkOut" />
            </Link>
          )}
        </div>
      )}

      {showShare && !merchantPreview && (
        <div className="flex justify-between sm:mt-4 container mx-auto space-x-4">
          <button onClick={() => handleBack()}>
            <div className="w-12 h-12 flex justify-center items-center bg-interaction-secondary hover:bg-interaction-secondary-hover focus:bg-interaction-secondary-pressed rounded-full transition">
              <ArrowLeft className="w-4 h-4" />
            </div>
          </button>

          <div className="flex items-center space-x-4">
            <ButtonV2
              size="medium"
              data-ref="share-button"
              variant="secondary"
              onClick={() => {
                clipboard.copy(
                  `https://${
                    process.env.NEXT_PUBLIC_APP_ENV === 'release'
                      ? 'app.planethowl.com'
                      : 'howl-web-staging.vercel.app'
                  }/publisher/campaign-center/campaigns/${strategy_id}`,
                );
                toast({
                  title: 'Copied to clipboard',
                  description: 'Share this link with your friends!',
                  variant: 'success',
                });
              }}
            >
              {clipboard.copied ? 'Copied' : 'Share'}
            </ButtonV2>
          </div>
        </div>
      )}

      {!merchantPreview && !disableTabs && (
        <TabbedCards styleType="block" tabClassNames="!overflow-x-hidden">
          <Tab
            name="Flat Fees"
            path="flat-fees"
            absolutePath={`/publisher/${router.query.publisherId}/campaign-center`}
            isShowing={flags.flatFee3}
          >
            <div className={classNames('relative w-full')}>
              {flatFee && children}
            </div>
          </Tab>
          <Tab
            name="Brands"
            path="brands"
            absolutePath={`/publisher/${router.query.publisherId}/campaign-center`}
            isShowing={true}
          >
            <div className={classNames('relative w-full')}>
              {brand && children}
            </div>
          </Tab>
          <Tab
            name="Campaigns"
            path="campaigns"
            absolutePath={`/publisher/${router.query.publisherId}/campaign-center`}
            isShowing={true}
          >
            <div className={classNames('relative w-full')}>
              {campaign && children}
            </div>
          </Tab>
        </TabbedCards>
      )}

      {!merchantPreview && disableTabs && (
        <div className="w-full flex flex-col relative">{children}</div>
      )}
      {merchantPreview && children}

      <ReservedModal />
    </div>
  );
};

export default CampaignCenterWrapper;
